import React, { FC } from 'react';
import { Redirect } from 'react-router';
import paths from '../paths';

const Agent: FC<void> = () => {
  return <Redirect to={paths.agent.leads} />;
};

export default Agent;
